import { render, staticRenderFns } from "./EditDeleteChallengesModal.vue?vue&type=template&id=8679e30e&scoped=true&"
import script from "./EditDeleteChallengesModal.vue?vue&type=script&lang=js&"
export * from "./EditDeleteChallengesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDeleteChallengesModal.vue?vue&type=style&index=0&id=8679e30e&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8679e30e",
  null
  
)

export default component.exports